import api from "../../utils/api";
import { Endpoint, getEndpointURL } from "../common/endpoints";
export const organisationSelf = async (organisationId, body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.OrganisationSelf, { organisationId }), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const organisationUpdateSelf = async (body, _queryParams, headers) => {
    return api.API.put(getEndpointURL(Endpoint.OrganisationUpdateSelf), {
        credentials: "include",
        headers,
        json: {
            organisations: body,
        },
    }).json();
};
export const organisationRequestPackage = async (organisationId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.OrganisationRequestPackage, { organisationId }), {
        credentials: "include",
        headers,
        json: {
            organisations: body,
        },
    }).json();
};
export const organisationEnforceMfa = async (body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.OrganisationEnforceMfa), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const organisationAcceptTermsAndConditions = async (body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.OrganisationAcceptTermsAndConditions), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const organisationPublicKeyUrl = async (body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.OrganisationPublicKeyUrl), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const organisationProposedLink = async (body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.OrganisationProposedLink), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const organisationApproveProposedLink = async (body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.OrganisationApproveProposedLink), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const organisationRejectProposedLink = async (body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.OrganisationRejectProposedLink), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
